import { deriveErrorMessage } from '@/util/deriveErrorMessage';
import { useMemo } from 'react';

export const useFormError = props => {
  const { errors, allowErrorMessages } = props;

  const derivedErrorMessage = useMemo(() => {
    const defaultErrorMessage = allowErrorMessages
      ? ''
      : 'An error has occurred. Please check the input and try again.';

    return deriveErrorMessage(errors, defaultErrorMessage);
  }, [errors, allowErrorMessages]);

  return {
    errorMessage: derivedErrorMessage,
  };
};
